<template>
  <div id="contenedor-main-contrato-anticipos">
    <tool-bar v-if="!soloLectura" class="my-3" v-on:registrarAnticipo="registrarAnticipo" />
    <!-- Loader -->
    <v-skeleton-loader
      v-if="$apollo.loading"
      type="table-heading, table-thead, table-tbody"
    ></v-skeleton-loader>
    <template v-if="getAnticipos.length < 1">
      <v-card flat>
        <v-card-text>
          <v-row justify="center" align="center">
            <v-alert class="mt-4" type="info"> No hay anticipos registrados. </v-alert>
          </v-row>
        </v-card-text>
      </v-card>
    </template>
    <template v-else>
      <listado
        v-if="!$apollo.loading"
        :solo-lectura="soloLectura"
        :listadoAnticipos="getAnticipos"
        :es-contrato-financiado="contrato.esObraFinanciada">
      </listado>
    </template>
    <!-- Ventana Registrar Anticipo -->
    <v-dialog
      v-if="esteContrato"
      v-model="mostrarRegistarAnticipo"
      width="650">
      <registrar-nuevo-anticipo
        :contrato="esteContrato"
        v-on:cerrar="cerrarVentana"
      />
    </v-dialog>
    <!-- Ventana Editar Anticipo -->
    <v-dialog
      v-if="esteAnticipo"
      v-model="mostrarEditarAnticipo"
      width="650">
      <editar-anticipo
        :contrato="esteContrato"
        :contratoAnticipoEditar="esteAnticipo"
        v-on:cerrar="cerrarVentana"
      />
    </v-dialog>
    <!-- Ventana Eliminar Anticipo -->
    <v-dialog
      v-if="esteAnticipo"
      v-model="mostrarEliminarAnticipo"
      :width="!$vuetify.breakpoint.xs ? '450' : '90%'">
      <eliminar-anticipo
        :contratoAnticipoEliminar="esteAnticipo"
        v-on:cerrar="cerrarVentana"
      />
    </v-dialog>
  </div>
</template>

<script>
import CONTRATO from '@/graphql/querys/administracion/contratos/contrato.gql';
import CONTRATO_ANTICIPOS from '@/graphql/querys/administracion/contratos/contrato/anticipos.gql';
import RegistrarNuevoAnticipo from '@/components/administracion/contratos/contrato/anticipo/Nuevo.vue';
import EditarAnticipo from '@/components/administracion/contratos/contrato/anticipo/Editar.vue';
import EliminarAnticipo from '@/components/administracion/contratos/contrato/anticipo/Eliminar.vue';
import eventBus from '@/helpers/eventBus';
import ToolBar from './ToolBar.vue';
import Listado from './listado/Main.vue';

export default {
  name: 'MainContratoAnticipos',
  components: {
    ToolBar,
    Listado,
    RegistrarNuevoAnticipo,
    EditarAnticipo,
    EliminarAnticipo,
  },
  props: {
    soloLectura: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  apollo: {
    contrato: {
      query: CONTRATO,
      variables() {
        return {
          id: this.$route.params.idContrato,
        };
      },
    },
    contratoAnticipos: {
      query: CONTRATO_ANTICIPOS,
      variables() {
        return {
          idContrato: this.$route.params.idContrato,
        };
      },
    },
  },
  data() {
    return {
      mostrarRegistarAnticipo: false,
      mostrarEditarAnticipo: false,
      mostrarEliminarAnticipo: false,
      mostrarRegistrarSolicitudPago: false,
      esteAnticipo: null,
      esteContrato: null,
    };
  },
  methods: {
    cerrarVentana() {
      this.mostrarRegistarAnticipo = false;
      this.mostrarEditarAnticipo = false;
      this.mostrarEliminarAnticipo = false;
      this.esteAnticipo = null;
      this.esteContrato = null;
    },
    registrarAnticipo() {
      this.esteContrato = this.contrato;
      this.mostrarRegistarAnticipo = true;
    },
  },
  computed: {
    getContrato() {
      if (!this.contrato) return {};
      return this.contrato;
    },
    getAnticipos() {
      if (!this.contratoAnticipos) return [];
      return this.contratoAnticipos
        .slice()
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    },
  },
  mounted() {
    eventBus.$on('editar-anticipo-contrato', (anticipoContrato) => {
      this.esteContrato = this.contrato;
      this.esteAnticipo = anticipoContrato;
      this.mostrarEditarAnticipo = true;
    });
    eventBus.$on('eliminar-anticipo-contrato', (anticipoContrato) => {
      this.esteAnticipo = anticipoContrato;
      this.mostrarEliminarAnticipo = true;
    });
  },
};
</script>

<style lang="scss">
</style>
